export default "<h1>Warning 警告色</h1>\n<p>警告模式是以辅助色为根基, 横向扩展的配色方案.</p>\n"